'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Toolbar button component!
 *
 * @type {Function}
 */

var ToolbarButton = function ToolbarButton(props) {
  return _react2.default.createElement(
    'span',
    {
      className: props.className || 'button',
      title: props.title,
      'data-active': props.active,
      onMouseDown: props.onMouseDown,
      role: 'button',
      tabIndex: 0
    },
    props.icon && _react2.default.createElement('i', { className: 'fa fa-' + props.icon, 'aria-hidden': 'true' }),
    props.text
  );
};

ToolbarButton.propTypes = {
  icon: _propTypes2.default.string,
  text: _propTypes2.default.string,
  onMouseDown: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  title: _propTypes2.default.string
};

exports.default = ToolbarButton;